import { useGlobalStore } from "@/store";
import { isYapiError, YapiError } from "@YenzaCT/sdk";

export function useApiCall() {
  const store = useGlobalStore();

  async function executeApi<T>(apiCall: () => Promise<T>): Promise<T | null> {
    try {
      store.networkBusy = true;
      return await apiCall();
    } catch (e) {
      if (isYapiError(e)) {
        await store.handleYapiError(e as YapiError);
      } else {
        throw e;
      }
      return null;
    } finally {
      store.networkBusy = false;
    }
  }

  return { executeApi };
}
